import React from "react";
import StackComponent from "../../components/Base/StackComponent";
import ImageComponent from "../../components/Base/ImageComponent";
import logo from "./../../assets/images/common/logo.png";
import TypographyComponent from "../../components/Base/TypographyComponent";
import social_logos from "./../../assets/icons/footer_logos";
import FooterURLs from "./FooterURLs";
import { FOOTER_URLS } from "../../config/constants";
import { useResponsive } from "../../hooks";

const FooterContent = () => {
  const { isMediumScreen, isSmallScreen, isExtraSmallScreen } = useResponsive();
  return (
    <StackComponent
      spacing={isSmallScreen ? "30px" : "96px"}
      justifyContent="space-between"
      alignItems={isMediumScreen ? "center" : "auto"}
      direction={isMediumScreen ? "column" : "row"}
    >
      <StackComponent
        direction="column"
        sx={{ width: isMediumScreen ? "100%" : "426px", flexGrow: 1 }}
      >
        <ImageComponent
          containerStyles={{
            marginBottom: "14px",
            ...(isSmallScreen ? { margin: "14px auto" } : null),
          }}
          source={logo}
          alt="logo"
          width="190px"
          height="46px"
        />
        {/* <TypographyComponent
          variant="totalLabel"
          component="p"
          sx={{
            width: isMediumScreen ? "100%" : "354px",
            mb: "54px",
            textAlign: isSmallScreen ? "center" : "left",
          }}
        >
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
          eiusmod tempor incididunt ut labore.
        </TypographyComponent> */}
        <StackComponent
          spacing="24px"
          sx={{
            width: isMediumScreen ? "auto" : "354px",
            alignSelf: isMediumScreen ? "center" : "auto",
          }}
        >
          {social_logos.map((eachLogo) => (
            <ImageComponent
              source={eachLogo}
              alt={eachLogo}
              width="40px"
              height="40px"
              containerStyles={{ cursor: "pointer" }}
            />
          ))}
        </StackComponent>
      </StackComponent>
      {FOOTER_URLS.map((eachFooterGroup) => (
        <FooterURLs
          {...{ isMediumScreen, isSmallScreen, isExtraSmallScreen }}
          key={eachFooterGroup.title.split(" ").join("-").toLowerCase()}
          title={eachFooterGroup.title}
          urlsArr={eachFooterGroup.urlsArr}
        />
      ))}
    </StackComponent>
  );
};

export default FooterContent;
